import { Injectable } from '@angular/core'
import { AresService } from './ares.service'
import {
  CompanyRegisterLookupError,
  CompanyRegisterLookupResult,
  CompanyRegisterProvider,
} from './company-register.models'
import { RpoService } from './rpo.service'

@Injectable({
  providedIn: 'root',
})
export class CompanyRegisterService {
  constructor(
    private aresService: AresService,
    private rpoService: RpoService
  ) {}

  public getProvider(country: string | null | undefined): CompanyRegisterProvider | null {
    switch (this.normalizeCountry(country)) {
      case '':
      case 'CZ':
        return 'ares'
      case 'SK':
        return 'rpo'
      default:
        return null
    }
  }

  public lookupAddress(
    country: string | null | undefined,
    ico: string | number | null | undefined
  ): Promise<CompanyRegisterLookupResult> {
    switch (this.getProvider(country)) {
      case 'ares':
        return this.aresService.lookupAddress(ico)
      case 'rpo':
        return this.rpoService.lookupAddress(ico)
      default:
        throw new CompanyRegisterLookupError('unavailable')
    }
  }

  private normalizeCountry(country: string | null | undefined): string {
    return country === null || country === undefined ? '' : String(country).trim().toUpperCase()
  }
}
